import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { isNewBOPISmessageEnabled } from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import { HOLIDAY_BOPIS_MESSAGE_CONTENT } from 'yoda-checkout-components/lib/common/Constants';
import * as messageContentAction from 'yoda-checkout-components/lib/actions/MessageContentAction';
import ShippingGroupDetails from '../ShippingGroupDetails/ShippingGroupDetails';

class ShippingGroupList extends Component {
    static propTypes = {
        orderAdjustments: PropTypes.arrayOf(PropTypes.object).isRequired,
        orderShippingGroupsInfo: PropTypes.arrayOf(PropTypes.object).isRequired,
        orderGiftRegistries: PropTypes.objectOf(PropTypes.object).isRequired,
        messageContentData: PropTypes.objectOf(PropTypes.object).isRequired,
        actions: PropTypes.objectOf(PropTypes.object),
    };

    static defaultProps = {
        actions: {},
    };

    componentDidMount() {
        const { messageContentData, actions } = this.props;
        if (!(messageContentData && messageContentData[HOLIDAY_BOPIS_MESSAGE_CONTENT])) {
            actions.getMessageContent(HOLIDAY_BOPIS_MESSAGE_CONTENT);
        }
    }

    getBOPISMessage = (bopisHolidayMessage) => {
        const { orderShippingGroupsInfo } = this.props;
        const bopisItems = get(orderShippingGroupsInfo, '[0].bagItems', []);
        return get(bopisItems, '[0].deliveryOptions[0].pickupDateMessage', bopisHolidayMessage);
    };

    renderShippingGroups() {
        const { messageContentData } = this.props;
        const bopisHolidayMessage = get(
            messageContentData,
            `${HOLIDAY_BOPIS_MESSAGE_CONTENT}.body`,
            ''
        );
        const bopisMessage = isNewBOPISmessageEnabled()
            ? this.getBOPISMessage(bopisHolidayMessage)
            : bopisHolidayMessage;
        return this.props.orderShippingGroupsInfo.map((shippingGroup) => (
            <ShippingGroupDetails
                key={shippingGroup.type}
                shippingGroupDetails={shippingGroup}
                orderAdjustments={this.props.orderAdjustments}
                bopisHolidayMessage={bopisMessage}
                orderGiftRegistries={this.props.orderGiftRegistries}
                pickupDateMessage={shippingGroup?.pickupDateMessage}
            />
        ));
    }

    render() {
        const { orderShippingGroupsInfo } = this.props;
        if (isEmpty(orderShippingGroupsInfo)) {
            return null;
        }

        return <div>{this.renderShippingGroups()}</div>;
    }
}

const mapStateToProps = ({
    orderAdjustments,
    orderShippingGroupsInfo,
    orderGiftRegistries,
    messageContentData,
}) => ({
    orderAdjustments,
    orderShippingGroupsInfo,
    orderGiftRegistries,
    messageContentData,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(Object.assign(messageContentAction), dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShippingGroupList);
